import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../footer/footer';
import ScrollToTop from '../hooks/ScrollToTop';
import CustomHeader from './header';
import AdsCarousel from '../home/sliderAds';

export default function MainLayout({ categorie }) {
  return (
    <>
      <AdsCarousel centro="false"></AdsCarousel>
      <CustomHeader categorie={categorie} />
      <ScrollToTop />
      <Outlet />
      <Footer />
    </>
  );
}
